import axios, { type CancelToken } from 'axios';

const azureBlobApi = axios.create();

export async function putAzureBlock(url: string, data: Blob, cancelToken?: CancelToken): Promise<void> {
    await azureBlobApi.put(url, data, {
        cancelToken,
        headers: {
            'x-ms-blob-type': 'BlockBlob',
        },
    });
}

export async function commitAzureBlockList(
    url: string,
    blockIds: string[],
    contentType: string,
    cancelToken?: CancelToken,
): Promise<void> {
    let requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';

    for (const blockId of blockIds) {
        requestBody += `<Latest>${blockId}</Latest>`;
    }

    requestBody += '</BlockList>';

    await azureBlobApi.put(`${url}&comp=blocklist`, requestBody, {
        cancelToken,
        headers: {
            'x-ms-blob-content-type': contentType,
        },
    });
}
